import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler, XMLHttpRequestHandler_requestType } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {featurePointsConfigView_template} from "../components/templates/featurePointsConfigView_template";
import { validationsList_template } from "../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/validationsList_template";
import { vn_app_zone_notification } from "../../vendor/valnet/valnet_jslib/vnApp/vn_app_zone_notification";

declare var ko: any;
declare var page: any;

export class featurePointsConfig_view extends vnModule_knockoutJS{

    protected XHRHdls: XMLHttpRequestHandler[] = [];
    protected XHRHdl: XMLHttpRequestHandler;
    protected validationsList: validationsList_template;
    protected featurePointsConfigViewTemplate: featurePointsConfigView_template;

    protected getModuleName(){
        return "featurePointsConfig_view";
    }

    buildContent() : Array<Element>{

        // create validation errors list template
        //this.validationsList = new validationsList_template("validationList", this.viewModel, this);

        this.featurePointsConfigViewTemplate = new featurePointsConfigView_template( "featurePointsConfigView_template", this.viewModel, this );

        return [this.featurePointsConfigViewTemplate.build()];
    }

    public fillPage() : void{
        this.getListFormData();
    }

    public getListFormData(): void{
        let usrReq_url: string = '/api/featurePoints/config/references/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON([])] );
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdl.onReadyStateFunction = this.onFilterRequestReturn;
        this.XHRHdl.execute();
    }

    protected onFilterRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.featurePointsConfigViewTemplate.validationsList.clearMessages();
                obj.updateFilters(responseParsed);

                obj.getListData();
            });

            if(req.request.readyState == 4){

                obj.loadingOut(obj.featurePointsConfigViewTemplate.builtTemplate);
            }
        };
    }

    public getListData(): void{
        this.loadingIn(this.featurePointsConfigViewTemplate.builtTemplate.children.namedItem("list-results"));
        this.featurePointsConfigViewTemplate.getTemplateViewModel().isTableLoading(1);

        /*if( "getListData" in this.XHRHdls ){
            this.XHRHdls["getListData"].cancelAndReset();
        }*/

        let subViewModel = this.featurePointsConfigViewTemplate.getViewModelForRequest();

        let usrReq_url: string = '/api/featurePoints/config/get/';
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(["data", ko.toJSON(subViewModel)] );
        this.XHRHdls["getListData"] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls["getListData"].onReadyStateFunction = this.onDataRequestReturn;
        this.XHRHdls["getListData"].execute();
    }

    protected onDataRequestReturn(req, obj){

        return function (){

            obj.manageResponse(req, obj, function (){

                let responseParsed = JSON.parse(req.request.response);

                obj.featurePointsConfigViewTemplate.validationsList.clearMessages();
                obj.updateList(responseParsed);
            });

            if(req.request.readyState == 4){

                // LOADING : ends
                obj.featurePointsConfigViewTemplate.getTemplateViewModel().isTableLoading(0);
                obj.loadingOut(obj.featurePointsConfigViewTemplate.builtTemplate.children.namedItem("list-results"));
            }
        };
    }

    protected updateList(responseParsed: any) {
        this.featurePointsConfigViewTemplate.setAssignees(responseParsed.data);
    }

    protected updateFilters(responseParsed: any){

        this.featurePointsConfigViewTemplate.setQuartersItems();
        this.featurePointsConfigViewTemplate.setYearsItems(responseParsed.years);
        this.featurePointsConfigViewTemplate.setDepartmentsFilterItems(responseParsed.departments);
        this.featurePointsConfigViewTemplate.setAssigneesFilterItems(responseParsed.assignees);
        this.featurePointsConfigViewTemplate.setDefaultDepartmentsSelected();
    }

    protected editAssignee(id,year,quarter){
        page('/feature_points/config/assignee/'+id+'/edit');
    }

    protected editHolidays(year,quarter){
        page('/feature_points/config/holidays/year/'+year+'/quarter/'+quarter+'/edit');
    }

    protected cancelConfig(){

        this.releaseLock();

        // redirect to earnings page or user list
        this.getVnAppZone().notification = new vn_app_zone_notification(vn_app_zone_notification.TYPE_WARNING, "User action canceled !");

        page.redirect('/feature_points');
    }

    protected releaseLock(){

        // request a lock release
        let usrReq_url: string = '/api/user/release/lock/' + this.getVnAppZone().app.params.id + '/';
        let usrReq_params: Array<Array<string>> = [];
        this.XHRHdl = new XMLHttpRequestHandler(usrReq_url, usrReq_params, this);
        this.XHRHdl.execute();
    }

    protected filterMultipleSelectorOnChange() {

        this.getListData();
    }

    public listReorder(){

        this.getListData();
    }
}


// WEBPACK FOOTER //
// ./js/modules/featurePointsConfig_view.ts